import { MealTypeDTO, MealTypesFormFields } from 'types';

export const parseMealTypeDTOIntoMealTypesFormFields = (
    mealTypeData: MealTypeDTO,
): MealTypesFormFields => ({
    name: mealTypeData.name,
});
